<template>
	<v-card class="elevation-0 partners-page partners-page-container page">
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null" class="d-flex">
			<v-skeleton-loader
				v-if="isLoading"
				v-bind="attrs"
				width="600"
				type="list-item, list-item-three-line, card-heading"
			>
			</v-skeleton-loader>

			<div v-else style="width: 100%">
				<div class="agenda-page__title mt-0">{{ this.name }}</div>
				<FilterChipButton
					class="mt-4"
					:isButtonActive="isButtonActive"
					:chipsList="chipsList"
					:clearFilter="clearFilter"
					@handleChipClick="handleChipClick"
				/>
				<div v-if="filterModalIsVisible">
					<FilterModal
						:filterModalIsVisible="filterModalIsVisible"
						:currentModalFilter="currentModalFilter"
						:currentModalLabel="currentModalLabel"
						:selectedChips="selectedChips"
						:filters="filters"
						:dateError="date.error"
						:dateOption="date.option"
						:dateRange="date.selectedRange"
						@closeModal="closeModal"
						@applySelection="applySelection"
						@setItem="setItem"
					/>
				</div>
				<div class="mt-5">
					<div v-for="(partner, index) in partners" :key="index">
						<PartnerCard :partner="partner" />
					</div>
				</div>

				<div
					class="d-flex my-9 justify-center home-page__pagination"
					v-if="!isLoading && partners.length > 0"
				>
					<Pagination
						:page="filters.page"
						:pageCount="+this.pageCountPartners"
						v-on:pageChange="onPageChange"
					/>
				</div>
			</div>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PartnerCard from '@/components/Event/PartnerCard'
import Pagination from '@/components/Pagination.vue'
import PageBlocked from '@/components/PageBlocked'
import ButtonBack from '@/components/ButtonBack'
import Block from '@/mixins/Block.js'
import Filter from '@/mixins/Filter'
import FilterChipButton from '@/components/FilterChipButtons.vue'
import FilterModal from '@/components/Modals/FilterModal.vue'

export default {
	name: 'PartnersPage',
	mixins: [Block, Filter],
	components: {
		FilterModal,
		FilterChipButton,
		PartnerCard,
		PageBlocked,
		Pagination,
		ButtonBack,
	},

	props: {
		name: {
			type: String,
			default: 'Partner',
		},
	},

	methods: {
		...mapActions('event', ['fetchPartners']),
	},

	created() {
		if (this.$route.params.id !== undefined && (!this.isBlocked || this.isBlocked === null)) {
			this.fetchPartners(this.requestQuery)
		}
	},

	computed: {
		...mapGetters('event', ['isLoading', 'pageCountPartners', 'partners']),
	},

	data() {
		return {
			attrs: {
				elevation: 0,
			},
			filters: {
				page: 1,
			},
			pageBlockedName: 'events',
		}
	},
}
</script>

<style lang="scss">
.partners-page {
	max-width: 600px;
	width: 100%;

	&__title {
		color: rgb(74, 74, 74);
		font-size: 24px;
		font-family: Montserrat sans-serif;
		font-weight: 700;
		margin-bottom: 10px;
	}
}
</style>
